module.exports = __webpack_public_path__ + "img/top1.8c0ce21b.png";